import { atom } from "recoil";
import { IEmailList } from "../types/EmailList";

export const AllEmailListAtom = atom<IEmailList[]>({
  key: "AllEmailsListAtom",
  default: [],
});
